<script setup lang="ts">
const { slug } = useRoute().params

const { story } = await useFetchStory(`lp/${slug}`).catch((error) => {
  throw createError({
    message: error,
    statusCode: 404,
  })
})

definePageMeta({
  middleware: 'redirect-lp-pages',
  key: (route) => route.fullPath,
})
useCustomHead(story)
const { layoutName, layoutNavbarColor, layoutFooterColor } = useStoryLayout<any>(story)
</script>

<template>
  <NuxtLayout :name="layoutName" :navbar-color="layoutNavbarColor" :footer-color="layoutFooterColor">
    <div v-if="story" class="lp-page-wrapper">
      <StoryblokComponent
        v-for="hero in story.content.hero"
        :key="hero._uid"
        :blok="hero"
      />
      <StoryblokComponent
        v-for="section in story.content.body"
        :key="section._uid"
        :blok="section"
      />
    </div>
  </NuxtLayout>
</template>
